import './CompteClient.scss';

import React, { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {Outlet, useLocation, useNavigate } from 'react-router-dom';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import {urlListeSideBar } from '../../../data/Interfaces';
import useWindowSize from '../../../hooks/useWindowSize';
import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';

function ProfilEntreprise() {

    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();
    const {device}=useWindowSize();
    const navigate = useNavigate();
    const [urlPage,setUrlPage]=useState('');
    const { i18n } = useTranslation();
    useEffect(() => {
        if(pathname){
            setUrlPage(pathname);
        }

    },[pathname]);

    const handleChangeUrl = async (e) => {
        const newUrl = e.target.value;
        await setUrlPage(newUrl);
        navigate(newUrl, { replace: true });
    };

    return (
        <>
            {device=='desktop' ?
                <div className='frame0SideBarClient'>
                    <div
                        className='DocumentscommerciauxT'
                        style={
                            (currentPath == 'donneesGenerales') ?
                                SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >
                        <p
                            style={
                                (currentPath == 'donneesGenerales') ?
                                    SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                            onClick={()=>{
                                if(currentPath == 'donneesGenerales')
                                    navigate('.');
                                else{
                                    navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/donneesGenerales', { replace: true });
                                }

                            }}

                        >{i18n.t('Profil entreprise')}</p>

                    </div>
                    <div
                        className='DocumentscommerciauxT'
                        style={
                            (currentPath == 'donneesFacturation') ?
                                SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >
                        <p
                            style={
                                (currentPath == 'donneesFacturation') ?
                                    SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                            onClick={()=>{
                                console.log('path', '/'+((pathname.split('/')).slice(1,-1)).join('/')+'/donneesFacturation');
                                // console.log('path', pathname.split('/').slice(1,-1));
                                navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/donneesFacturation', { replace: true });
                            }}
                        >{i18n.t('Données Facturation')}</p>
                    </div>
                    <div
                        className='DocumentscommerciauxT'
                        style={
                            currentPath == 'donneesPC' ?
                                SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >

                        <p
                            style={
                                currentPath == 'donneesPC' ?
                                    SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                            onClick={()=>{
                                navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/donneesPC', { replace: true });
                            }}
                        >{i18n.t('Données PC')}</p>
                    </div>
                    <div>
                        <Outlet />
                    </div>
                </div>
                :
                <>
                    <div style={{widt:'100%',minWidth:'200px',maxWidth:'500px'}}>
                        <SelectComponent
                            val={urlPage}
                            setVal={(e) => handleChangeUrl(e)}
                            listVal={urlListeSideBar}
                        />
                    </div>
                </>
            }
        </>
    );
}

export default ProfilEntreprise;